export const environment = {
  production: false,
  apiUrl: 'https://ennhsr-api.nhsrc.net',
  originUrl: 'https://ennhsr-api.nhsrc.net',
  isDesktop: false,
  allRoles: [
    'Category D',
    'Category C',
    'Category B',
    'Category A',
    'Unit Manager'
  ]
};
